const map = {
	"./BigPicture.jpg": 10512,
	"./DE_Add_to_Apple_Wallet_RGB.svg": 83837,
	"./ECheckinBackground.jpg": 35102,
	"./EN_Add_to_Apple_Wallet_RGB.svg": 18789,
	"./FR_Add_to_Apple_Wallet_RGB.svg": 52804,
	"./IT_Add_to_Apple_Wallet_RGB.svg": 82039,
	"./KGPageHeader.jpg": 30132,
	"./Logo.svg": 19314,
	"./Picture.jpg": 63204,
	"./TopArea.jpg": 5408
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90891;